import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    authToken: localStorage.getItem("access_token"),
    newChat: false,
    selectedDB: "Database 1",
    selectedModule: "All",
};

export const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        setAuthToken: (state, action) => {
            return {
                ...state,
                authToken: action.payload,
            };
        },
        setNewChat: (state, action) => {
            return {
                ...state,
                newChat: action.payload,
            };

        },
        setSelectedDB: (state, action) => {
            return {
                ...state,
                selectedDB: action.payload,
            }
        },
        setSelectedModule: (state, action) => {
            return {
                ...state,
                selectedModule: action.payload,
            };
        },

    },

});

// Action creators are generated for each case reducer function
export const {
    setAuthToken,
    setNewChat,
    setSelectedDB,
    setSelectedModule,
} = globalSlice.actions;

export default globalSlice.reducer;
